import React from 'react';

const ROLE_CONFIG = {
  SUPER_ADMIN: { label: 'Super Admin', bg: 'bg-purple-100', text: 'text-purple-700' },
  ADMIN: { label: 'Admin', bg: 'bg-blue-100', text: 'text-blue-700' },
  OPERATOR: { label: 'Operador', bg: 'bg-cyan-100', text: 'text-cyan-700' },
  CUSTOMER_USER: { label: 'Usuario', bg: 'bg-gray-100', text: 'text-gray-600' },
};

const RoleBadge = ({ role }) => {
  const config = ROLE_CONFIG?.[role] || ROLE_CONFIG?.CUSTOMER_USER;
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold font-caption ${config?.bg} ${config?.text}`}>
      {config?.label}
    </span>
  );
};

export default RoleBadge;